function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import cx from 'classnames';
import { camelCaseToArray } from '../../utils/helpers';
/**
 * Map component's props
 *
 * @param {object} props - Component's props
 * @param {object} map - map { [input prop]: [component's prop] }
 */

export var getMapedProps = function getMapedProps(props, map) {
  return map ? Object.keys(map).reduce(function (acc, key) {
    return Object.assign(acc, _defineProperty({}, map[key], props[key]));
  }, _objectSpread({}, props)) : props;
};
/**
 * Filter props by keys array
 *
 * @param {object} props - props to filter
 * @param {array} filterProps - array of keys to filter
 */

export var getFilteredPropsKeys = function getFilteredPropsKeys(props, filterProps) {
  return Object.keys(props).filter(function (prop) {
    return filterProps.filter(function (key) {
      return prop.startsWith(key);
    }).length;
  });
};
/**
 * Filter local props by map
 *
 * @param {object} props - props to filter
 * @param {object} map - component's props map
 * @param {object} localMap - component's local map
 */

export var getLocalPropsKeys = function getLocalPropsKeys(props, map) {
  var localMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Object.keys(getMapedProps(props)).filter(function (prop) {
    return Object.keys(map || localMap).filter(function (key) {
      return prop.startsWith(key);
    }).length;
  });
};
/**
 * Filter piped props keys by map
 *
 * @param {object} props - props to filter
 * @param {object} map - component's props map
 * @param {object} localMap - component's local map
 */

export var getPipedPropsKeys = function getPipedPropsKeys(props, map) {
  var localMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return Object.keys(getMapedProps(props, map)).filter(function (prop) {
    return !Object.keys(map || localMap).filter(function (key) {
      return prop.startsWith(key);
    }).length;
  });
};
/**
 * Filter piped props by map
 *
 * @param {object} props - props to filter
 * @param {object} map - component's props map
 * @param {object} localMap - component's local map
 */

export var getPipedProps = function getPipedProps(props, map) {
  var localMap = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return getPipedPropsKeys(props, map, localMap).reduce(function () {
    var pipedProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var key = arguments.length > 1 ? arguments[1] : undefined;
    return Object.assign(pipedProps, _defineProperty({}, key, getMapedProps(props, map)[key]));
  }, {});
};
/**
 * Make class name for complex prop. Example:
 *
 * paddingTopXl={40} => 'padding-top-xl-40'
 *
 * @param {object} props - props to filter
 * @param {object} map - component's props map
 * @param {object} prop - component's prop
 * @param {object} css - css to take class from
 */

export var makeComplexPropClass = function makeComplexPropClass(props, map, prop, css) {
  var classParts = [].concat(_toConsumableArray(camelCaseToArray(prop)), [props[prop]]);
  var prefixedClassParts = map ? [map[classParts[0]] || classParts[0]].concat(_toConsumableArray(classParts.slice(1))) : classParts;
  return css[prefixedClassParts.join('-')];
};
/**
 * Generate class names for enhancer component
 *
 * @param {object} props - props to filter
 * @param {object} map - component's props map
 * @param {object} prop - component's prop
 * @param {object} css - css to take class from
 */

export var generateClassNames = function generateClassNames(props, map, localMap, className, css) {
  var localClassNames = getLocalPropsKeys(props, map, localMap).map(function (prop) {
    return makeComplexPropClass(props, map, prop, css);
  });
  return cx.apply(void 0, [className].concat(_toConsumableArray(localClassNames)));
};